<template>
  <div class="top-view">
    <div :class="item.tabViewActive" v-for="(item,index) in topList" :key="index"
         @mouseover="mouseover(item)"
         @mouseleave="mouseleave(item)"
         @click="handleClick(item)">
      <div :class="activeIndex === item.tabIndex ? 'text-view-active' : 'text-view'">
        {{item.tabText}}
      </div>
      <div class="line-view"></div>
    </div>
    <div class="user-meta-view" v-if="platformToken">
      <div class="meta-text" >
        当前登录用户:{{platformUserData.userName}}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import LoginView from './LoginView'
export default {
  name: "TopView",
  components:{

  },
  props: {
    topList:{
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex:0,
      platformUserData:{},
      //platformToken:''
    };
  },
  mounted() {
    /*this.platformUserData = JSON.parse(localStorage.getItem("platformUserData"));
    this.platformToken = localStorage.getItem("platformToken");*/
  },
  computed: {
    platformToken() {
      return this.$store.state.platformToken
    }
  },
  watch: {

  },
  methods: {
    handleClick(item) {
      this.activeIndex = item.tabIndex;
      this.$emit('switchTabIndex',item.tabIndex);
    },
    mouseover(item) {
      console.log('mouseover')
      item.tabViewActive = 'tab-on-mouse-view'
    },
    mouseleave(item){
      console.log('mouseleave')
      item.tabViewActive = 'tab-view'
    },
  },
}
</script>

<style lang="scss" scoped>
.top-view{
  width: 100%;
  background-color: #2f3842;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-end;
  .tab-on-mouse-view{
    margin: 20px 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: #72767a;
    cursor:pointer;
    .text-view-active{
      font-size: 25px;
      font-weight: bold;
      color: #4d99e5;
    }
    .text-view{
      font-size: 25px;
      font-weight: bold;
      color: #edeeef;
    }
    .line-view{
      width: 100%;
      background-color: #edeeef;
      height: 3px;
    }
  }
  .tab-view{
    margin: 20px 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .text-view-active{
      font-size: 25px;
      font-weight: bold;
      color: #4d99e5;
    }
    .text-view{
      font-size: 25px;
      font-weight: bold;
      color: #edeeef;
    }
    .line-view{
      width: 100%;
      background-color: #edeeef;
      height: 3px;
    }
  }
  .user-meta-view{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin: 20px 0px;
    cursor:pointer;
    .meta-text{
      font-size: 10px;
      font-weight: bold;
      color: #c5d5e7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// TopView.vue?680c7e75